import { createApp } from "vue";
import { createPinia } from "pinia";
import * as Sentry from "@sentry/vue";
import Vue3Sanitize from "vue-3-sanitize";
import { getClientId } from "@utils/clientId";
import { initAnalytics } from "@/lib/analytics";

import "@styles/shadcn.css";
import "@styles/assistant.css";

/* application specific */
import router from "./routes";
import App from "./App.vue";
import ActionCableVue from "actioncable-vue";

import VueLazyLoad from "vue3-lazyload";

// create Vue instance
const app = createApp(App);

initAnalytics();

Sentry.init({
  app,
  dsn: "https://40b13b285721e372202b69558a50d610@o4510698449141760.ingest.de.sentry.io/4510798858223697",
  release: import.meta.env.VITE_GITHUB_SHA,
  environment: import.meta.env.MODE,
  sendDefaultPii: true,
});

// declare router
app.use(router);

// tags authorised by sanitize
const overridenOptions = {
  allowedTags: ["strong", "em", "br", "a"],
  allowedAttributes: {
    a: ["href", "target", "rel"],
  },
  allowedClasses: {},
  allowedSchemesAppliedToAttributes: ["href"],
};
// declare vue-3-sanitize
app.use(Vue3Sanitize, overridenOptions);

app.use(VueLazyLoad);
// declare actioncable
const clientId = getClientId();
if (process.env.NODE_ENV === "development") {
  app.use(ActionCableVue, {
    debug: true,
    debugLevel: "all",
    connectionUrl: `ws://${window.location.host}/cable?client_id=${clientId}`,
  });
} else {
  app.use(ActionCableVue, { connectionUrl: `/cable?client_id=${clientId}` });
}

// create and declare Pinia instance
const pinia = createPinia();
app.use(pinia);

// mount app
app.mount("#app");
